import { render, staticRenderFns } from "./ProductPermissions.vue?vue&type=template&id=605b0792"
import script from "./ProductPermissions.vue?vue&type=script&lang=js"
export * from "./ProductPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports